<template>
  <div id="contenedor-configuracion-firma-desktop">
    <v-list>
      <template v-if="listado.length">
        <template
          v-for="(firma, index) in listado">
          <v-list-item
            :key="firma.id"
            class="px-0">
            <v-list-item-avatar>
              <v-icon>
                mdi-account-tie
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <div class="d-flex align-center mb-1">
                <v-chip
                  small
                  color="primary"
                  text-color="white"
                  class="mr-2 font-weight-bold">
                  Orden de firma {{ firma.orden }}
                </v-chip>
                <v-list-item-title class="font-weight-medium">
                  {{ firma.funcionario.nombre }}
                </v-list-item-title>
              </div>
              <v-list-item-subtitle class="mb-1">
                {{ firma.funcionario.puesto || 'Sin puesto asignado' }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="d-flex align-center flex-wrap">
                <v-icon
                  x-small
                  class="mr-1">
                  mdi-calendar-account
                </v-icon>
                Nombramiento: {{ formatoFecha(firma.funcionario.fechaNombramiento) }}
                <span class="mx-2">•</span>
                <v-icon
                  x-small
                  class="mr-1">
                  mdi-clock-outline
                </v-icon>
                Registro:
                <fecha-humano
                  class="ml-1"
                  :fecha="firma.createdAt">
                </fecha-humano>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-tooltip
                left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="error"
                    v-bind="attrs"
                    v-on="on"
                    @click="$emit('eliminar', firma)">
                    <v-icon>
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </template>
                <span>Eliminar firma</span>
              </v-tooltip>
            </v-list-item-action>
          </v-list-item>
          <v-divider
            v-if="index < listado.length - 1"
            :key="`divider-${firma.id}`">
          </v-divider>
        </template>
      </template>
      <v-list-item v-else>
        <v-list-item-content>
          <v-list-item-title>
            No hay firmantes registrados.
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';

export default {
  name: 'ConfiguracionFirmasDesktop',
  components: {
    FechaHumano,
  },
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  methods: {
    formatoFecha(fecha) {
      if (!fecha) return 'Sin fecha';
      return this.$moment(fecha).format('DD/MM/YYYY');
    },
  },
};
</script>

<style lang="scss">

</style>
